import React, { useState, useCallback, useMemo, useContext,useEffect } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import { useQuery, useQueryClient } from "react-query";
import { DeleteOutlined, EditOutlined, EyeOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Avatar, Button, Modal, Spin } from "antd";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../Styles/style.css"
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import {getDrivers } from "../../Drivers/services/driverApi";
import { useTranslation } from "react-i18next"; 
import { getStatus } from "../../Status/services/statusApi";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import { useNavigate } from "react-router-dom";
import vectorIcon from '../../../assets/images/Vector.png'; 
import vector1Icon from '../../../assets/images/Vector1.png';
import { getInspection, getInspectionByCategory } from "../../Inspection/services/inspectionsApi";
import TableContainerMin from "../../../Components/Common/TableContainer";
import { deleteTypeInspection } from "../../TypeInspection/services/typeApi";


const Incidents = (modal) => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  document.title = `Incidents | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleteTargetRegistrationNumber, setDeleteTargetRegistrationNumber] = useState("");
  const { isLoading, isError, error, data: filteredIncidents = [] } = useQuery("filteredIncidents ", getInspectionByCategory);
   const { data: drivers, isLoading: isLoadingDrivers, isError: isErrorDrivers } = useQuery("drivers", getDrivers);
   const {data: status, isLoadingStatus: isLoadingStatus, isErrorStatus:isErrorStatus}=useQuery("status",getStatus )
   const [isModalOpen, setIsModalOpen] = useState(false);
   const toggleModal = useCallback((incident = null) => {
    setSelectedIncident(incident); 
    setIsModalOpen(prev => !prev);  
  }, []);
const getStatusColor = (status) => {
  switch (status) {
    case 'Résolues':
      case 'Résolues #2FB550':
      case 'Actif #2FB550':
      return '#2FB550';
    case 'En attente':
      return ' #FF2D55';
    default:
      return ' #FF9500';
  }
};
   useEffect(() => {
    if (drivers) {
  
    }
  }, [drivers]);
  useEffect(() => {
    if (status) {
    }
  }, [status]);
  const toggleAddEditModal = useCallback((incident = null) => {
    setSelectedIncident(incident);
    setIsAddEditModalOpen(prev => !prev);
    if (isDetailModalOpen) setIsDetailModalOpen(false);
  }, [isDetailModalOpen]);

  const handleEdit = (incident) => {
    toggleAddEditModal(incident);
  };
  const toggleDetailModal = useCallback((incident = null) => {
    setselectedIncident(incident);
    setIsDetailModalOpen(prev => !prev);
    if (isAddEditModalOpen) setIsAddEditModalOpen(false);
  }, [isAddEditModalOpen]);
  const handleDetail = (incidentId) => {
    if(incidentId){
      navigate(`/incident/detail/${incidentId}`);
  }
 
  };
  const handleDelete = async (incidentId) => {
    try {
      await deleteTypeInspection(incidentId);
      queryClient.invalidateQueries("filteredIncidents");
      toast.success("L'incident a été supprimée avec succès 🎉");
    } catch (error) {
      console.error("Error deleting incident:", error);
      toast.error(`😔 Erreur lors de la suppression de l'incident : ${error?.message||error}`);
    } finally {
      setDeleteConfirmModal(false);
    }
  };
  const openDeleteConfirmModal = (incidentId) => {
    const incidentToDelete = inspecions.find(incident => incident.id === incidentId);
    if (incidentToDelete) {
      setDeleteTargetId(incidentId);
      setDeleteTargetRegistrationNumber(incidentToDelete.registrationNumber);
      setDeleteConfirmModal(true);
    }
  };
  const closeDeleteConfirmModal = () => {
    setDeleteConfirmModal(false);
  };
  
  const columns = useMemo(() => [
    
    {
      Header: () => (
        <div style={{ textAlign: "start",  color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}}>
    {t("menu.vehicles")}
        </div>
      ),
      accessor: "vehicle",
      Cell: ({ row }) => {
        const avatarImageVehicle= row?.original?.vehicle?.fileName;
   const imageUrlVehicle = avatarImageVehicle
   ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageVehicle}`:avatar1;
   const handleRedirectToDetails = () => {
   
    handleDetail(row?.original?.id);  
  };

        return (
          <div     onClick={handleRedirectToDetails} className="text-center" style={{ display: "flex", alignItems: "center" }}     >
            {isLoading ? (
              "Chargement..."
            ) : row?.original ? (
              <>
                <Avatar
                  src={imageUrlVehicle }
                  alt=""
                  style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "8px" }}
                />
         <span style={{ textDecoration: 'underline', cursor:'pointer'}}>{row?.original?.vehicle?.model}</span>
              </>
            ) : (
              t("vehicle.no_driver")
            )}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: () => <div style={{textAlign: "start",  color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}}>Criticité</div>,
      accessor: "revisions",  
      Cell: ({ row }) => {
        const status = row.original.revisions && row.original.revisions.length > 0 
          ? row.original.revisions[0]?.status  
          : "Aucun criticité"; 
        let color = "";
        if (status === "Elévée") {
          color = "#2FB550"; 
        } else if (status === "Modéré") {
          color = "#FFCC00"; 
        } else if (status === "Faible") {
          color = "#F22A2A"; 
        }
        return (
          <div className="text-start">
            <span 
              style={{
                width: "10px", 
                height: "10px", 
                borderRadius: "50%", 
                backgroundColor: color, 
                display: "inline-block", 
                marginRight: "8px"
              }} 
            />
            {status}
          </div>
        );
      },
      filterable: false
    },
    
    
     {
      Header: () => (
        <div style={{ textAlign: "start",  color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}}>
          {t("vehicle.driver")}
        </div>
      ),
      accessor: "userId",
      Cell: ({ row }) => {
        const driverId = row.original.userId;
        const driver = drivers?.find(driver => driver.id === driverId);
        const avatarImage= driver?.fileName;
   const imageUrl = avatarImage
   ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`:avatar1;
        return (
          <div className="text-center" style={{ display: "flex", alignItems: "center" }}>
            {isLoadingDrivers ? (
              "Chargement..."
            ) : driver ? (
              <>
                <Avatar
                  src={imageUrl }
                  alt=""
                  style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "8px" }}
                />
                {driver.name}
              </>
            ) : (
              t("vehicle.no_driver")
            )}
          </div>
        );
      },
      filterable: false,
    },
    { Header:()=><div style={{textAlign:"center",  color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}} >Libellé de l’incident</div> ,
    accessor: "typeInspection",
    Cell:({row})=>(
     <div className="text-center">{row.original.typeInspection ||t("vehicle.no_registration_number")}</div>),
    
     filterable: false
     },
    {
      Header: () => <div style={{ textAlign: "center" ,fontWeight: "normal"}}>Date de soumission</div>,
      accessor: "createdAt",
      Cell: ({ value }) => (
        <div style={{ textAlign: "center" }}>
          {value ? new Date(value).toLocaleDateString('fr-FR') : "-"}
        </div>
      ),
      filterable: false,
    },
        {
          Header: () => (
            <div style={{ textAlign: 'start',  color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px'}}>
              {t('vehicle.status')}
            </div>
          ),
          accessor: 'status',
          Cell: ({ row }) => {
            const statut = row?.original?.status || '---';
            const color = getStatusColor(statut);
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
                <span
                  style={{
                    display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    marginRight: '8px',
                  }}
                ></span>
                <span>{statut}</span>
              </div>
            );
          },
          filterable: false,
        },
         
        {
          Header: () => <div style={{ textAlign: "end", color:'#434343',fontSize:'14px',fontFamily:'Inter',fontWeight:'500px' }}>{t("vehicle.actions")}</div>,
          accessor: "action",
          headerStyle: { textAlign: "text-center" },
          Cell: ({ row }) => (
            <div className="actions-cell">        
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "50%",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                  cursor: "pointer"
                }}
                onClick={() => toggleModal(row.original)}  // Ouvre le modal avec les détails de la ligne sélectionnée
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="6" cy="12" r="2" fill="#151515" />
                  <circle cx="12" cy="12" r="2" fill="#151515" />
                  <circle cx="18" cy="12" r="2" fill="#151515" />
                </svg>
              </div>
            </div>
          ),
          filterable: false,
        },
  
  ], [handleEdit, openDeleteConfirmModal, handleDetail]);
  

  const tabs = ['Tout', 'Résolues', 'En attente', 'Archivés'];
    const [activeTab, setActiveTab] = useState('Tout');
    const handleTabChange = (tab) => {
      setActiveTab(tab);
    };

 
  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
     
      
    },
    bigButton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px 10px", // Réduit la taille du bouton
      backgroundColor: '#F6F6F6',
      color: "white",
      border: "none",
      borderRadius: "40px", // Légèrement arrondi mais plus petit
      cursor: "pointer",
      fontSize: "16px", // Taille réduite pour le texte
      position: "relative", // Pour contenir les onglets à l'intérieur
    },
    tabContainer: {
      display: "flex",
      gap: "5px", // Espacement réduit entre les onglets
      flexDirection: "row",
      
    },
    tabButton: {
      padding: "5px 16px", // Réduit la taille des onglets
      border: "none",
      borderRadius: "20px", 
      
      cursor: "pointer",
      fontSize: "14px", 
      transition: "background-color 0.3s",
      font:"Inter",
      fontWeight: "bold",
      backgroundColor: '#F6F6F6',
  
    },
  };
// Filtrer les véhicules dont le statut est "En service"
const filteredIncidentsInTraites = filteredIncidents.filter(incident => incident.status === 'Résolues');
const numberOfInspectionsInTraites  =  filteredIncidentsInTraites.length;
const filteredIncidentsEnAttente = filteredIncidents.filter(incident => incident.status === 'En attente');
const numberOfInspectionsEnAttente = filteredIncidentsEnAttente.length;
const filteredIncidentsArchive= filteredIncidents.filter(incident => incident.status === 'Archives');
const numberOfInspectionsArchive = filteredIncidentsArchive.length;
const [isModalOpenExport, setIsModalOpenExport] = useState(false);
const toggleModalExport = () => {
  setIsModalOpenExport(prev => !prev);
};
 const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  // Gestion de la sélection/dé-sélection de toutes les cases
  const handleSelectAll = () => {
    setIsAllSelected(!isAllSelected);
    if (!isAllSelected) {
      // Sélectionner toutes les lignes
      setSelectedRows(filteredIncidents.map(incident => incident.id));
    } else {
      // Deselect toutes les lignes
      setSelectedRows([]);
    }
  };

  // Gestion de la sélection/dé-sélection d'une ligne spécifique
  const handleSelectRow = (id) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        // Si la ligne est déjà sélectionnée, la désélectionner
        return prevSelectedRows.filter(rowId => rowId !== id);
      } else {
        // Si la ligne n'est pas sélectionnée, la sélectionner
        return [...prevSelectedRows, id];
      }
    });
  };
  const [isChecked, setIsChecked] = useState(false)
  // Fonction pour gérer le changement de l'état du checkbox
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  // Combiner les deux fonctions dans une nouvelle fonction
const handleCheckboxAndSelectAll = () => {
  handleCheckboxChange(); // Inverser l'état du checkbox global
  handleSelectAll(); // Gérer la sélection/désélection des lignes
};
  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      <div style={styles.container}>
        <button style={styles.bigButton}>
          <div style={styles.tabContainer}>
            {tabs.map((tab) => (
              <button
                key={tab}
                style={{
                  ...styles.tabButton,
                  backgroundColor: activeTab === tab ? "#151515" : "#F6F6F6",
                  color: activeTab === tab ? "#FFFFFF" : "#595959", // Texte en blanc si actif, gris sinon
                }}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
                {tab === 'Tout' && (
                  <div
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: activeTab === 'Tout' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                      color: activeTab === 'Tout' ?  '#FFFFFF':'#595959', // Couleur de texte en fonction de l'état
                      fontSize: '12px', // Correction de la taille de police
                      marginLeft: '5px',
                    }}
                  >
                    {filteredIncidents?.length}
                  </div>
                )}
                 {tab === 'Résolues' && (
                  <div
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: activeTab === 'Résolues' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                      color: activeTab === 'Résolues' ?  '#FFFFFF':'#595959',
                      fontSize: '12px',
                      marginLeft: '5px',
                    }}
                  >
                    { numberOfInspectionsInTraites}
                   
                  </div>
                )}
                {tab === 'En attente' && (
                  <div
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: activeTab === 'En attente' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                         color: activeTab === 'En attente' ?  '#FFFFFF':'#595959',
                      fontSize: '12px',
                      marginLeft: '5px',
                    }}
                  >
                     { numberOfInspectionsEnAttente}
                  
                  </div>
                )}
               
                {tab === 'Archivés' && (
                  <div
                  style={{
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: activeTab === 'Archivés' ? '#3D3D3D' : '#D9D9D9', // Cercle blanc si actif, gris sinon
                      color: activeTab === 'Archivés' ?  '#FFFFFF':'#595959',
                    fontSize: '12px',
                    marginLeft: '5px',
                  }}
                >
                   {numberOfInspectionsArchive}
                </div>
                )}
              </button>
            ))}
          </div>
        </button>
      </div>
    </div>
  );
  <div className="d-flex gap-3">{renderTabs()}</div>
  const navigate = useNavigate();
  const HeaderTable = () => (
    <div className="gap-3">
        <div className="d-flex justify-content-between align-items-center w-100">
           
        <div className="d-flex gap-3">
          <strong style={{ fontSize: "24px" }}>
           Incidents
          </strong>
        </div>
      
        {/* Conteneur flex pour aligner les deux boutons */}
        <div
          style={{
            display: "flex",
            alignItems: "center", 
            gap: "10px", 
          }}
        >
          {/* Bouton Export */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px", 
              height: "30px",
              backgroundColor: "#f5f5f5",
              borderRadius: "50%",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
              cursor: "pointer",
            }}
            onClick={toggleModalExport}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Points du bouton d'export */}
              <circle cx="6" cy="12" r="2" fill="#151515" />
              <circle cx="12" cy="12" r="2" fill="#151515" />
              <circle cx="18" cy="12" r="2" fill="#151515" />
            </svg>
          </div>
         
        </div>
      </div>
      <div style={{ marginTop: "20px" }}></div> 
      {renderTabs()}
      </div>
     
      );
  const filteredfilteredIncidents = useMemo(() => {
    if (!filteredIncidents) return error?.message||[];
    switch (activeTab) {
      case 'Résolues':
        return filteredIncidents.filter(v => v.status === 'Résolues');
      case 'En attente':
        return filteredIncidents.filter(v => v.status === 'En attente');
      case 'Archivés':
        return filteredIncidents.filter(v => v.status === 'Archive');
      default:
        return filteredIncidents;
     
    }
  }, [filteredIncidents, activeTab]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page={t("filteredIncidents.filteredIncidents" )}history={history} />
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable />
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    data={filteredfilteredIncidents}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    
                  />
                   {isLoading && !isError && (
                                      <div className="text-center">
                                        {t("global.loading")}
                                        <Spin />
                                      </div>
                                    )}
                  {filteredfilteredIncidents && filteredfilteredIncidents.length === 0 && !isLoading && (
                    <div>{t("global.no-data-v")}</div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
           <Modal
            title="Confirmer la suppression de ce véhicule"
            open={deleteConfirmModal}
            onCancel={closeDeleteConfirmModal}
          footer={[
                   <Button key="cancel" onClick={closeDeleteConfirmModal} className="bordered-btn-delete">
                  {t("global.no")}
                   </Button>,
                <Button key="delete" type="danger"  onClick={() => handleDelete(deleteTargetId)} className="bordered-btn">
                {t("global.yes")}
              </Button>,
  ]}
  width={400}
  style={{ top: 200 }} 
>
  <p>{t("vehicle.confirm_delete_vehicle")} {deleteTargetRegistrationNumber} ?</p>
</Modal>
<Modal
className={`modal-right ${modal ? 'open' : ''}`}  
visible={isModalOpenExport}
onCancel={toggleModalExport}
  footer={null}
  width={261}
  height={120}
  radiuis={9.6} 
  border={0.96}
>
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
   
    <a
  onClick={() => {

 
    toggleModalExport();
  }}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    alignItems: "center" 
  }}
>
  <img src={vector1Icon} alt="Export en csv" style={{ marginRight: '8px' }} />
  <span>Exporter en CSV</span >
</a>

  </div>
</Modal>   
<Modal
  open={isModalOpen}
  onCancel={() => toggleModal()} 
  footer={null}
  width={190}
  height={10}
  radiuis={9.6} 
  border={0.96}
  
style={{top:'350px',right:'10px',position:'absolute'}}
 
>
<div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <a 
    onClick={() => handleDetail(selectedIncident?.id)}
      style={{
         display: "flex",
    alignItems: "center",
       marginRight:'8px',
      fontFamily:"inter",
      fontWeight:'400px',
        width: "100%",
        marginBottom: "16px" 
      }}
    >
    <EyeOutlined style={{ color: ' #898989',width:'20px' }}  />
     <span style={{size:'14px',color:" #252525"}} >Voir détails</span>
    </a>
  
<a
  onClick={() => openDeleteConfirmModal(selectedIncident.id)}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    marginBottom: "16px" 
    
  }}
>
<DeleteOutlined style={{ color: ' #898989' }} />     
  <span style={{marginLeft:'10px'}} >Supprimer</span >
</a>
<a
  onClick={() => {
    toggleModal();
  }}
  style={{
    marginRight: '8px',
    fontFamily: "inter",
    fontWeight: '400px',
    fontSize: '14px', 
    color: "#252525",
    width: "100%",
    display: "flex",
    alignItems: "center" 
    
  }}
>

</a>
  </div>
</Modal>     
</Container>
      </div>
    </React.Fragment>
  );
};
export default Incidents;
